import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BrowserHelper from 'src/app/helpers/browser-helper';
import { BaseProject } from 'src/app/model/project/base-project';
import { Project } from 'src/app/model/project/project';
import {
  SUB_PROJECT_TYPES,
  SubProject,
} from 'src/app/model/project/sub-project';

@Component({
  selector: 'divergent-price-collapse',
  templateUrl: './divergent-price-collapse.component.html',
  styleUrls: ['./divergent-price-collapse.component.scss'],
})
export class DivergentPriceCollapseComponent implements OnInit {
  @Input() baseProject: BaseProject;
  @Input() subProject: SubProject;
  @Input() project: Project;
  @Input() collaborative = false;
  @Input() showSave = false;
  @Input() savingLines = false;

  @Output() public save = new EventEmitter();
  @Output() saveLines = new EventEmitter();
  @Output() divergentPricesChecked = new EventEmitter<boolean>();

  divergentPricesCollapsed = true;
  safari: boolean;

  SUB_PROJECT_TYPES = SUB_PROJECT_TYPES;

  constructor() {}

  ngOnInit(): void {
    this.safari = BrowserHelper.isSafari();
    this.divergentPricesCollapsed =
      this.subProject == null ||
      this.subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT;
  }
}
